/* Wishlist: saved in this browser only (localStorage), no login. Hearts on every product card and the product page,
   a count in the header, and the /pages/wishlist page with live price and stock from the store. Wording: Theme settings. */
(() => {
  const KEY = 'cv-wishlist';
  let cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('cv-wl-config').textContent);
  } catch (e) {}

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter((x) => x && typeof x === 'object' && x.handle) : [];
    } catch (e) {
      return [];
    }
  };
  let list = read();
  const write = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  };
  const has = (id) => list.some((x) => String(x.id) === String(id));

  /* toast */
  let toastEl;
  let toastTimer;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.append(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('on'), 2200);
  }

  /* hearts and header count */
  function paint(scope = document) {
    scope.querySelectorAll('.cv-heart').forEach((h) => {
      const on = has(h.dataset.wl);
      h.setAttribute('aria-pressed', on);
      h.setAttribute('aria-label', on ? cfg.remove : cfg.save);
    });
    document.querySelectorAll('[data-cv-wl-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = !list.length;
    });
    document.querySelectorAll('.cv-wl-link').forEach((a) => a.setAttribute('aria-label', (cfg.label || '') + (list.length ? ' (' + list.length + ')' : '')));
  }
  const changed = () => document.dispatchEvent(new CustomEvent('cv:wishlist'));

  document.addEventListener('click', (e) => {
    const h = e.target.closest('.cv-heart');
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    const id = String(h.dataset.wl);
    const i = list.findIndex((x) => String(x.id) === id);
    if (i > -1) list.splice(i, 1);
    else list.push({ id, handle: h.dataset.handle });
    write();
    paint();
    toast(i > -1 ? cfg.toastRemoved : cfg.toastSaved);
    changed();
  });
  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return;
    list = read();
    paint();
    changed();
  });

  // Cards that appear later (recommendations, filtered collections) get their hearts painted too.
  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(() => paint(), 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- the wishlist page ---------- */
  function setupPage(root) {
    if (root.__wl) return;
    root.__wl = true;
    const T = JSON.parse(root.dataset.text || '{}');
    const grid = root.querySelector('[data-cv-wl-grid]');
    const empty = root.querySelector('[data-cv-wl-empty]');
    const loading = root.querySelector('[data-cv-wl-loading]');
    const cache = new Map();
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };
    const sized = (u, w) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const get = (handle) => {
      if (!cache.has(handle)) {
        cache.set(
          handle,
          fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        );
      }
      return cache.get(handle);
    };
    function card(p, entry, idx) {
      // Like the cards: link to the first variant in stock and show that variant's own photo.
      const vs = p.variants || [];
      const v = vs.find((x) => x.available) || vs[0];
      const url = vs.length > 1 && v ? '/products/' + p.handle + '?variant=' + v.id : p.url || '/products/' + p.handle;
      const sold = !p.available;
      const vimg = v && v.featured_image && v.featured_image.src;
      const main = vimg || p.featured_image || (p.images && p.images[0]);
      const same = (a, b) => String(a).split('?')[0] === String(b).split('?')[0];
      const alt = (p.images || []).find((i) => !same(i, main));
      const sizes = '(min-width: 1200px) 280px, (min-width: 980px) 24vw, 46vw';
      const img = (src, cls, label, first) => (src ? '<img class="' + cls + '" src="' + sized(src, 480) + '" srcset="' + [240, 360, 480, 720].map((w) => sized(src, w) + ' ' + w + 'w').join(', ') + '" sizes="' + sizes + '" alt="' + esc(label || '') + '" ' + (first ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + ' width="480" height="480">' : '');
      return (
        '<li class="cv-card cv-wlcard' + (sold ? ' is-out' : '') + '" data-id="' + esc(entry.id) + '">' +
        (sold ? '<span class="cv-card__badge so">' + esc(T.soldOut) + '</span>' : '') +
        '<button class="cv-heart" type="button" data-wl="' + esc(entry.id) + '" data-handle="' + esc(entry.handle) + '" aria-pressed="true" aria-label="' + esc(cfg.remove) + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.2 4.9 13.3C3.4 11.8 2.6 10.3 2.6 8.6A4.9 4.9 0 0 1 7.5 3.7c1.8 0 3.2.8 4.5 2.3 1.3-1.5 2.7-2.3 4.5-2.3a4.9 4.9 0 0 1 4.9 4.9c0 1.7-.8 3.2-2.3 4.7Z"/></svg></button>' +
        '<a class="cv-card__pic" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img(main, 'main', p.title, idx < 4) + img(alt, 'alt') + '</a>' +
        '<div class="cv-card__info"><h2 class="cv-card__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h2>' +
        '<span class="cv-card__price">' + (p.price_varies ? esc(T.from) + ' ' : '') + money(p.price) + '</span>' +
        '<span class="cv-card__low cv-wlcard__stock' + (sold ? ' is-out' : '') + '">' + esc(sold ? T.soldOut : T.inStock) + '</span></div>' +
        '<div class="cv-wlcard__actions">' +
        (sold
          ? '<a class="cv-wlbtn cv-wlbtn--ghost" href="' + esc(url) + '#notify">' + esc(T.notify) + '</a>'
          : '<a class="cv-wlbtn" href="' + esc(url) + '">' + esc(T.view) + '</a>') +
        '</div></li>'
      );
    }
    async function render() {
      const entries = list.slice();
      if (!entries.length) {
        grid.innerHTML = '';
        empty.hidden = false;
        loading.hidden = true;
        return;
      }
      empty.hidden = true;
      const products = await Promise.all(entries.map((e) => get(e.handle)));
      const html = products.map((p, i) => (p ? card(p, entries[i], i) : '')).join('');
      loading.hidden = true;
      grid.innerHTML = html;
      empty.hidden = !!html;
      paint(grid);
    }
    document.addEventListener('cv:wishlist', render);
    render();
  }

  const init = (scope = document) => {
    paint(scope);
    scope.querySelectorAll('[data-cv-wl-page]').forEach(setupPage);
  };
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  init();
})();
